var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.75 35C47.845 35 45.5 32.655 45.5 29.75V12.25C45.5 9.345 47.845 7 50.75 7C53.655 7 56 9.345 56 12.25V29.75C56 32.655 53.655 35 50.75 35Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.75 35H66.5V29.75C66.5 26.845 68.845 24.5 71.75 24.5C74.655 24.5 77 26.845 77 29.75C77 32.655 74.655 35 71.75 35Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 49C36.155 49 38.5 51.345 38.5 54.25V71.75C38.5 74.655 36.155 77 33.25 77C30.345 77 28 74.655 28 71.75V54.25C28 51.345 30.345 49 33.25 49Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 49H17.5V54.25C17.5 57.155 15.155 59.5 12.25 59.5C9.345 59.5 7 57.155 7 54.25C7 51.345 9.345 49 12.25 49Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50.75C49 47.845 51.345 45.5 54.25 45.5H71.75C74.655 45.5 77 47.845 77 50.75C77 53.655 74.655 56 71.75 56H54.25C51.345 56 49 53.655 49 50.75Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 66.5H49V71.75C49 74.655 51.345 77 54.25 77C57.155 77 59.5 74.655 59.5 71.75C59.5 68.845 57.155 66.5 54.25 66.5Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33.25C35 30.345 32.655 28 29.75 28H12.25C9.345 28 7 30.345 7 33.25C7 36.155 9.345 38.5 12.25 38.5H29.75C32.655 38.5 35 36.155 35 33.25Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 17.5H35V12.25C35 9.345 32.655 7 29.75 7C26.845 7 24.5 9.345 24.5 12.25C24.5 15.155 26.845 17.5 29.75 17.5Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.1f3e8081664741934c9e306eb2e90f57.svg";
export { ForwardRef as ReactComponent };